import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Grid, IconButton, InputAdornment } from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import Iconify from '../../../components/iconify';
import { useFormContext } from '../../../hooks/useForm';
import TextInput from '../../../components/FormInputs/TextInput';
import SelectInput from '../../../components/FormInputs/SelectInput';

QuestionOption.propTypes = {
  option: PropTypes.object,
  selectedInput: PropTypes.string,
  questionId: PropTypes.string,
  selectedType: PropTypes.string,
  sectionId: PropTypes.string,
};

export default function QuestionOption({
  option,
  selectedInput,
  questionId,
  selectedType,
  sectionId,
}) {
  const { modifyOption, deleteOption, sections } = useFormContext();
  const [updatedOption, setUpdatedOption] = useState(option || {});
  const [selectedRedirectValue, setSelectedRedirectValue] = useState(
    option.redirectTo || '0'
  );

  const { t } = useTranslation();
  const { isSmallScreen } = useResponsiveScreen();

  const handleOptionChange = () => {
    modifyOption(option.id, { ...option, ...updatedOption });
  };

  const handleOptionRedirect = (value) => {
    setSelectedRedirectValue(value);
    modifyOption(option.id, { ...option, redirectTo: value });
  };

  // Build section list, excluding the section this question belongs to
  const sectionsOptions = Object.values(sections)
    .filter((section) => section.id !== sectionId)
    .map((section) => ({
      text: `${t('pages.formPage.goToSection')} ${section.name}`,
      value: section.id,
    }));

  sectionsOptions.unshift({ text: t('pages.formPage.chooseSection'), value: '0' });

  const showRedirectSelector =
    (selectedInput === 'SelectInput' || selectedInput === 'RadioInput') &&
    selectedType === t('pages.formPage.goToSectionBaseOn');

  return (
    <Grid container mt={2} mb={2} ml={isSmallScreen ? 1 : 0} alignItems="center">
      <Grid item xs={isSmallScreen ? 9 : showRedirectSelector ? 6 : 11}>
        <TextInput
          name="option"
          label={t('pages.formPage.optionLabel')}
          variant="standard"
          color="info"
          size={isSmallScreen ? 'small' : 'medium'}
          defaultValue={updatedOption.text || ''}
          onChange={(e) =>
            setUpdatedOption({ ...option, text: e.target.value, value: e.target.value })
          }
          onBlur={handleOptionChange}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => deleteOption(questionId, option.id)}
                  edge="end"
                >
                  <Iconify icon="ph:x-bold" />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiInputLabel-root': {
              fontSize: isSmallScreen ? '0.8rem' : '1rem',
            },
            '& .MuiInputBase-input': {
              fontSize: isSmallScreen ? '0.8rem' : '1rem',
            },
          }}
        />
      </Grid>

      {showRedirectSelector && (
        <Grid item xs={5} sx={{ textAlign: 'end', mt: isSmallScreen ? 2 : 0 }}>
          <SelectInput
            labelValue={t('pages.formPage.action')}
            name="Type selector"
            defaultValue={selectedRedirectValue}
            options={sectionsOptions}
            setSelectedInput={handleOptionRedirect}
          />
        </Grid>
      )}
    </Grid>
  );
}
